import { Pipe, PipeTransform } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';

@Pipe({name: 'calendarModeTranslationPipe'})

export class LocalizationCalendarModePipe extends BaseViewComponent implements PipeTransform {
    transform(value: string): string {
        switch (value) {
            case 'Day':
                return $localize`:@@TeacherPortalCalendarViewDay:Day`;
            case 'Week':
                return $localize`:@@TeacherPortalCalendarViewWeek:Week`;
            case 'Month':
                return $localize`:@@TeacherPortalCalendarViewMonth:Month`;
            case 'Timeline':
                return $localize`:@@TeacherPortalCalendarViewTimeline:Timeline`;
            case 'WeekList':
                return $localize`:@@TeacherPortalCalendarViewWeek:Week`;
            case 'WeekAgenda':
                return $localize`:@@TeacherPortalCalendarViewWeek:Week`;
            case 'MonthList':
                return $localize`:@@TeacherPortalCalendarViewMonth:Month`;
            case 'MonthGrid':
                return $localize`:@@TeacherPortalCalendarViewMonth:Month`;
            default:
                return value;
        }
    }
}
